import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_LOCALIZED_MEMBERSHIP_ASK_HEADLINE = defineFcm('revenue_localized_membership_ask_headline')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: {
					type: 'boolean',
					default: false,
					description: 'Whether the localized membership ask headline is enabled.',
				},
				state_localization_enabled: {
					type: 'boolean',
					default: false,
					description:
						'Whether the localized membership ask headline is enabled for US states. If true, the headline will be localized based on the user’s state.',
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'corgi-middle-end',
		context: 'Membership Asks, PPMU',
		description:
			"This FC controls the display of localized membership ask headline using signature service data for user's country or state (for US only).",
		import: false,
		template: {
			enabled: true,
			state_localization_enabled: true,
		},
		deprecated: 'No references found. Safe to delete after 2026-09-01.',
	});
